<script lang="ts" setup>
import CheckList from "@/components/CheckList.vue";
import CtaBanner from "@/components/CtaBanner.vue";
import CtaButton from "@/components/CtaButton.vue";

const { t } = useI18n();
const imageSrc = ref("");

withDefaults(
  defineProps<{
    international?: boolean;
  }>(),
  { international: false }
);

const checklistItems = [
  t("startPage.ctaBanner.aiDSGVOCompliant.checklist.1"),
  t("startPage.ctaBanner.aiDSGVOCompliant.checklist.2"),
  t("startPage.ctaBanner.aiDSGVOCompliant.checklist.3", {
    href: "/t/school_classes/info",
  }),
];

onMounted(async () => {
  const imageModule = await import(
    `@/images/cta_banner/${t("startPage.ctaBanner.aiDSGVOCompliant.image")}.png`
  );
  imageSrc.value = imageModule.default;
});
</script>

<template>
  <CtaBanner class="cta-banner-ai" :direction-row="true">
    <div class="cta-banner-ai__image">
      <img :src="imageSrc" alt="ai-dsgvo-compliant" loading="lazy" />
    </div>
    <div class="cta-banner-ai__text">
      <h2 class="cta-banner-ai__title">
        {{ t("startPage.ctaBanner.aiDSGVOCompliant.title") }}
      </h2>
      <p
        v-safe-html="t('startPage.ctaBanner.aiDSGVOCompliant.text')"
        class="cta-banner-ai__content"
      />

      <CheckList :items="checklistItems" />

      <CtaButton v-if="!international" href="/users/sign_up">
        {{ t("startPage.ctaBanner.startFree") }}
      </CtaButton>
    </div>
  </CtaBanner>
</template>

<style lang="scss" scoped>
.cta-banner-ai {
  &__image {
    width: 45%;

    @include media-breakpoint-down(md) {
      width: 100%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: center;
    }
  }

  &__text {
    width: 55%;
    @include media-breakpoint-down(md) {
      width: 100%;
    }
  }

  &__title {
    color: $color-primary;
    font-size: $h1-font-size;
    font-weight: $font-weight-semibold;
    line-height: 2.5rem;
    margin-bottom: 2.5rem;
  }

  &__content {
    font-size: $h5-font-size;
    line-height: 1.875rem;
  }

  @include media-breakpoint-down(xl) {
    gap: $spacer-5;
    padding: $spacer-5;

    &__title {
      font-size: $h2-font-size;
      margin-bottom: 1.25rem;
    }
  }

  @include media-breakpoint-down(md) {
    padding: $spacer-4;
    gap: $spacer-4;

    &__title {
      font-size: $h3-font-size;
      line-height: 2rem;
    }
  }
  @include media-breakpoint-up(md) {
    flex-direction: row-reverse;
  }
}
</style>
